module.exports = __webpack_public_path__ + "img/54.d331559f.jpg";